













import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'Contact',
})
export default class SocialMedia extends Vue {
    private contacts = [
      {
        icon: 'email',
        title: 'contact@highstormrecords.com',
      },
      {
        icon: 'phone',
        title: '+34 648 70 37 34',
      },
    ];
}
